module.exports = __webpack_public_path__ + "static/media/DSC09713.8ec5e30e.jpg";